<template lang="html">
<div class="mapbox-gl-map" :id="id">
    <div id="attribution" class="mapboxgl-ctrl mapboxgl-ctrl-attrib mapboxgl-ctrl-bottom-right" style="position: fixed; bottom: 0;">
        <div class="mapboxgl-ctrl mapboxgl-ctrl-attrib">
            <a href="https://www.mapbox.com/about/maps/" target="_blank">© Mapbox</a> &nbsp;|&nbsp;
            <a href="https://www.openstreetmap.org/about/" target="_blank">© OpenStreetMap</a> &nbsp;|&nbsp;
            <a target="_blank" href="https://www.foundryspatial.com/">Foundry Spatial <img style="margin: -3px -3px -3px 2px; width: 15px;" src="../assets/foundryLogo.svg"></a>
        </div>
    </div>
</div>
</template>

<script>
import mapboxgl from 'mapbox-gl';

export default {
    name: 'mapbox-gl-map',
    props: [
        'id',
        'options',
        'accessToken',
    ],
    data() {
        return {
            map: null,
        };
    },
    mounted() {
        // initialize MapboxGL map
        mapboxgl.accessToken = this.accessToken;
        this.map = new mapboxgl.Map(Object.assign({
            container: this.id,
            minZoom: 4,
            maxZoom: 15,
        }, this.options));

        // disable map rotation using right click + drag
        this.map.dragRotate.disable();

        // disable map rotation using touch rotation gesture
        this.map.touchZoomRotate.disableRotation();

        // emit 'loaded' event
        this.map.on('load', (loadEvent) => {
            this.$emit('loaded', this.map, loadEvent);
        });
    },
};
</script>

<style lang="css">
.mapbox-gl-map {
    flex: 1 1 100%;
}

.lat-lng {
    position: fixed;
    bottom: 55px;
    z-index: 1;
    margin-left: 10px;
}

/* override vuetify global styles */
.mapboxgl-ctrl-group > button {
    margin: 0;
}
/* .mapboxgl-control-container > .mapboxgl-ctrl-bottom-right {
    display: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/MapboxGlMap.vue